import { useCallback, useEffect, useState } from "react";


export default function usePagination(paramName = "page", defaultPage = 1) {
	const urlParams = new URLSearchParams(window.location.search);
	const pageParam = urlParams.get(paramName);
	const pageNumber = parseInt(pageParam, 10);

	const [page, setPage] = useState(pageNumber || defaultPage);

	const updatePageFromUrl = useCallback(() => {
		if (pageParam) {
			if (!isNaN(pageNumber) && pageNumber > 0) setPage(pageNumber);
			else setPage(defaultPage);
		}
		else setPage(defaultPage);
	}, [paramName, defaultPage]);

	const updatePage = useCallback((newPage, replaceState = false) => {
		const url = new URL(window.location.href);
		const params = url.searchParams;

		if (newPage === defaultPage) params.delete(paramName);
		else params.set(paramName, newPage.toString());

		const newUrl = `${url.pathname}${params.toString() ? `?${params.toString()}` : ""}`;

		if (replaceState) window.history.replaceState({}, "", newUrl);
		else window.history.pushState({}, "", newUrl);

		// Update the local state
		setPage(newPage);
	}, [paramName, defaultPage]);

	useEffect(() => {
		// Initial load
		updatePageFromUrl();

		window.addEventListener("popstate", updatePageFromUrl);

		return () => window.removeEventListener("popstate", updatePageFromUrl);
	}, [updatePageFromUrl]);

	return {
		page,
		updatePage
	};
};